import React, { Component } from "react";

import { DKLabel, DKButton } from "deskera-ui-library";
import RouteManager, { PAGE_ROUTES } from "../../managers/RouteManager";
import DirectLinkSection from "../common/DirectLinkSection";
import FunnelManager from "./FunnelManager";

class FunnelDomain extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDataAvailable: FunnelManager.isFunnelDataAvailable(),
    };
  }
  componentDidMount() {
    RouteManager.setPresenter(this);
    if (!FunnelManager.isFunnelDataAvailable() && this.props.match.params.id) {
      FunnelManager.fetchFunnelDataById(this.props.match.params.id, () => {
        this.setState({
          isDataAvailable: FunnelManager.isFunnelDataAvailable(),
        });
      });
    }
  }
  render() {
    return (
      <div className="column parent-width  ">
        <div
          className="column p-xl bg-white border-radius-s parent-width border-box mt-xxl align-self-center shadow-s align-items-center"
          style={{ maxWidth: 800, marginBottom: 100 }}
        >
          <div className="" style={{ fontSize: 50 }}>
            🥳
          </div>
          <DKLabel
            text="Hurray! Funnel Published"
            className="fw-m mt-m fs-xl"
          />
          <DKLabel
            text="Your funnel pages have been created successfully"
            className="mt-s"
          />

          {/* /////////// */}

          {this.state.isDataAvailable && (
            <DirectLinkSection
              className="mt-xl"
              url={FunnelManager.getDirectLink()}
            />
          )}

          {/* /////////// */}

          <DKLabel
            text="You can visit to form homepage / list page to see how it is performing."
            className="mt-xxl "
          />

          <div className="row border-box justify-content-center mt-l">
            <DKButton
              title="Back"
              className="bg-gray1 border-m "
              onClick={() => {
                RouteManager.navigateToPage(PAGE_ROUTES.FUNNEL_BUILDER);
              }}
            />
            <DKButton
              title="Funnel list"
              className="bg-app text-white ml-r"
              onClick={() => {
                RouteManager.navigateToPage(PAGE_ROUTES.FUNNEL);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default FunnelDomain;
